import { render, staticRenderFns } from "./ParentsList.vue?vue&type=template&id=c955e484&scoped=true&"
import script from "./ParentsList.vue?vue&type=script&lang=js&"
export * from "./ParentsList.vue?vue&type=script&lang=js&"
import style0 from "./ParentsList.vue?vue&type=style&index=0&id=c955e484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c955e484",
  null
  
)

export default component.exports